import { render, staticRenderFns } from "./SimpleErrorModal.vue?vue&type=template&id=03b9b42a&scoped=true"
import script from "./SimpleErrorModal.vue?vue&type=script&lang=js"
export * from "./SimpleErrorModal.vue?vue&type=script&lang=js"
import style0 from "./SimpleErrorModal.vue?vue&type=style&index=0&id=03b9b42a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b9b42a",
  null
  
)

export default component.exports